import { PageHeader, Section, DividerGold } from "@/components/layout/Section";
import { CreditCard, Wallet, Landmark, Smartphone, Heart } from "lucide-react";

const methods = [
  { icon: CreditCard, name: "Stripe / Card", desc: "Give securely with Visa, Mastercard, and other major cards. Coming soon.", cta: "Give with Card", disabled: true },
  { icon: Wallet, name: "PayPal", desc: "Send your seed via PayPal. Coming soon.", cta: "Give via PayPal", disabled: true },
  { icon: Smartphone, name: "Mobile Money", desc: "MTN / Vodafone / AirtelTigo. Reference: CLBC-<your name>.", cta: "View Details", disabled: false },
  { icon: Landmark, name: "Bank Transfer", desc: "Direct bank deposit or transfer to CLBC's official account.", cta: "View Details", disabled: false },
];

export default function Give() {
  return (
    <div data-testid="give-page">
      <PageHeader
        kicker="Giving"
        title="Sow into Kingdom soil."
        subtitle="Your seed fuels the Gospel — souls saved, disciples raised, communities transformed. Thank you for partnering with God through Christ Love Breed Church."
      />

      <Section>
        <div className="max-w-3xl mx-auto text-center">
          <p className="scripture text-lg">
            "Each of you should give what you have decided in your heart to give, not reluctantly or under compulsion, for God loves a cheerful giver."
          </p>
          <p className="text-xs uppercase tracking-widest text-gold-500 mt-3">2 Corinthians 9:7</p>
          <DividerGold className="mt-8" />
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-6">
          {methods.map((m, i) => (
            <div
              key={m.name}
              className="card-soft p-8"
              data-testid={`give-method-${i}`}
            >
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-royal to-royal-800 text-gold flex items-center justify-center shadow-md">
                  <m.icon className="w-6 h-6" />
                </div>
                <h3 className="font-serif text-2xl text-royal">{m.name}</h3>
              </div>
              <p className="mt-5 text-slate-600 leading-relaxed">{m.desc}</p>
              {m.name === "Mobile Money" && (
                <div className="mt-4 text-sm text-slate-600 space-y-1 bg-slate-50 rounded-xl p-4">
                  <div><span className="text-royal font-semibold">MTN MoMo:</span> +233 000 000 000</div>
                  <div><span className="text-royal font-semibold">Vodafone:</span> +233 000 000 000</div>
                  <div><span className="text-royal font-semibold">AirtelTigo:</span> +233 000 000 000</div>
                </div>
              )}
              {m.name === "Bank Transfer" && (
                <div className="mt-4 text-sm text-slate-600 space-y-1 bg-slate-50 rounded-xl p-4">
                  <div><span className="text-royal font-semibold">Bank:</span> Church Bank Name</div>
                  <div><span className="text-royal font-semibold">Account Name:</span> Christ Love Breed Church</div>
                  <div><span className="text-royal font-semibold">Account No:</span> 0000000000000</div>
                  <div><span className="text-royal font-semibold">Branch:</span> Main Branch</div>
                </div>
              )}
              <button
                disabled={m.disabled}
                className={`mt-6 ${m.disabled ? "btn-ghost opacity-70 cursor-not-allowed" : "btn-primary"} text-sm`}
                data-testid={`give-cta-${i}`}
              >
                <Heart className="w-4 h-4" /> {m.cta}
              </button>
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
}
